var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFollowers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83301 11.718V18.333H0.333008C0.33292 17.3871 0.534116 16.452 0.92323 15.5899C1.31234 14.7277 1.88047 13.9583 2.58986 13.3326C3.29924 12.7069 4.13365 12.2393 5.03765 11.961C5.94165 11.6826 6.89454 11.5998 7.83301 11.718ZM6.99967 10.833C4.23717 10.833 1.99967 8.59551 1.99967 5.83301C1.99967 3.07051 4.23717 0.833008 6.99967 0.833008C9.76217 0.833008 11.9997 3.07051 11.9997 5.83301C11.9997 8.59551 9.76217 10.833 6.99967 10.833ZM11.8272 16.5947L14.773 13.6488L15.9522 14.8272L11.8272 18.9522L8.88051 16.0055L10.0597 14.8272L11.8263 16.5947H11.8272Z",
    fill: "#999999"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowers);
export default __webpack_public_path__ + "static/media/followers.290dfe65d99c8baeba7bf6f8eb65b033.svg";
export { ForwardRef as ReactComponent };